import { Box } from '@mui/material';
import React from 'react';
export const TreeItemHoverContent = ({ sx, children }) => {
    return (React.createElement(Box, { sx: [
            {
                display: 'none',
                flexShrink: 0,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], className: 'tree-item-hover-content' }, children));
};
